import styles from './AddPracticeProblemCategoryButton.module.less'
import React, { ReactElement, useState } from 'react'
import { Button, Modal } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'
import { AddPracticeProblemCategory } from '@/components/PracticeProblemCategories/AddPracticeProblemCategoryButton/AddPracticeProblemCategory/AddPracticeProblemCategory'
import { useRecoilValue } from 'recoil'
import { isActiveCourseReadOnlySelector } from '@/atoms/auth'

export const AddPracticeProblemCategoryButton: React.FC<
    unknown
> = (): ReactElement => {
    const isReadOnly = useRecoilValue(isActiveCourseReadOnlySelector)
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <div className={styles.addPracticeProblemCategoryButtonContainer}>
            <Button
                onClick={() => setIsModalVisible(true)}
                size={'large'}
                disabled={isReadOnly}
            >
                <PlusCircleOutlined />{' '}
                <span>Add practice problem category</span>
            </Button>
            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                destroyOnClose={true}
            >
                <AddPracticeProblemCategory
                    closeModal={() => setIsModalVisible(false)}
                />
            </Modal>
        </div>
    )
}
